
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import OSD from 'openseadragon'
import PatCaseInfo from '../diagnosis/patCaseInfo'
import ScollerView from '../../base/scollerView'
import {eventBus} from '../../../eventbus'
const cropWidth = 100
const minZoomFactor = 1 / 400
const maxZoomFactor = 1
const maxSliderHeight = 160
const maxZoom = 400
const minZoom = 1
export default {
components: {OSD, Flexbox, FlexboxItem, XButton, XDialog, XProgress, Box, Popup, Group, Cell, Checker, CheckerItem, Confirm, XTextarea, PatCaseInfo, ScollerView},
data () {
return {
$vue: '',

caseType: '',

caseId: this.$route.params.caseid,

slideLayerId: '',

slideLayerTileSource: '',

dnaIndexStandard: 2.5,
diagnoseCropMax: '',
diagnoseCropMin: '',
patCaseInfo: new Map(),
cropList: [],
pressCropId: '',
showCrop: false,
showCropExplain: false,
cropExplain: '',
viewer: '',
imagingHelper: '',
showNavigator: true,
showZoom: true,
showPerCaseInfo: false,
showBottom: true,
displayZoom: 0,
zoomPercent: 0,
zoomFactor: 0
}
},
methods: {

async casePoolInfo () {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId.toString())
let suc = await this.$http.post(this.$vue.getData('CASE_POOL_CROP_INFO_URL'), params)
if (suc.data.result === '1') {
let data = suc.data.data
this.caseType = data.caseType

let patCase = new Map()
patCase.set('caseName', data.caseName)
patCase.set('patName', data.patName)
patCase.set('patSex', data.patSex)
patCase.set('patAge', data.patAge)
patCase.set('patHologyId', data.patHologyId)
patCase.set('isDifficult', data.isDifficult)
patCase.set('medicalHistory', data.medicalHistory)
patCase.set('clinicalDiagonse', data.clinicalDiagonse)
this.patCaseInfo = patCase

this.dnaIndexStandard = data.diStandard

this.diagnoseCropMax = data.diagnoseCropMax
this.diagnoseCropMin = data.diagnoseCropMin

let slideLayerArray = data.slideLayerInfo
this.slideLayerId = slideLayerArray[0].slideLayerId
this.slideLayerTileSource = slideLayerArray[0].layerAddr

this.getCropList()
}
},

isShowZoom () {
this.showZoom = !this.showZoom
},

isShowNav () {
this.showNavigator = !this.showNavigator
if (this.showNavigator) {
this.viewer.navigator.element.style.display = 'inline-block'
} else {
this.viewer.navigator.element.style.display = 'none'
}
},

isShowPerCaseInfo () {
this.showPerCaseInfo = !this.showPerCaseInfo
},

async getCropList () {
let params = new URLSearchParams()
params.append('caseId', this.caseId.toString())
params.append('slideLayerId', this.slideLayerId.toString())
let suc = await this.$http.post(this.$vue.getData('CASE_SAMPLE_CROP_URL'), params)
this.cropList = suc.data.curDoctorCropList
},

jumpToCropLocation (crop) {

let x = this.imagingHelper.dataToLogicalX(crop.STARTX)
let y = this.imagingHelper.dataToLogicalY(crop.STARTY)
let zoom = crop.ZOOMFACTOR
this.imagingHelper.centerAboutLogicalPoint(this.imagingHelper.getOSDPoint(x, y), false)
this.imagingHelper.setZoomFactor(zoom, true)

if (this.pressCropId !== crop.CROP_ID) {
this.pressCropId = -1
}

event.stopPropagation()
},

isShowCrop () {
this.showBottom = !this.showBottom
this.showCrop = !this.showBottom
},

isShowCropExplain (index) {
this.showCropExplain = !this.showCropExplain
if (this.showCropExplain) {
this.cropExplain = this.cropList[index].DETAIL_INFO
}
},
onImageViewChanged () {

this.zoomFactor = this.imagingHelper.getZoomFactor()
},

cancelView () {
this.$router.go(-1)
},
clickImg (cropId) {
event.stopPropagation()
}
},
computed: {

computeScrollWidth: function () {
return this.cropList.length * cropWidth + 'px'
}
},
watch: {

slideLayerTileSource: function (val, oldval) {

this.viewer = OSD.OpenSeadragon({
id: 'viewer', // 指定显示的div
crossOriginPolicy: 'anonymous', // 设置支持跨域
tileSources: this.slideLayerTileSource,
visibilityRatio: 1, // 图片在框内的最小比例
minZoomImageRatio: 1,
constrainDuringPan: true, // 禁止拽出范围
maxZoomPixelRatio: 1, // 图片的最大缩放比
zoomInButton: 'zinbtn', // 放大
zoomOutButton: 'zoutbtn', // 缩小
homeButton: 'homebtn', // 恢复默认
fullPageButton: 'fullpagebtn', // 全屏
showNavigator: true,
navigatorAutoFade: false, // 禁用自动隐藏导航视图
navigatorPosition: 'ABSOLUTE',
navigatorTop: '5px',
navigatorHeight: '150px',
navigatorWidth: '150px'
})

this.imagingHelper = this.viewer.activateImagingHelper({onImageViewChanged: this.onImageViewChanged})

this.viewer.scalebar({
type: OSD.OpenSeadragon.ScalebarType.MICROSCOPY,
pixelsPerMeter: 3700000,
minWidth: 70,
location: OSD.OpenSeadragon.ScalebarLocation.BOTTOM_LEFT,
xOffset: 5,
yOffset: 60,
stayInsideImage: true,
color: 'rgb(150, 150, 150)',
fontColor: 'rgb(100, 100, 100)',
backgroundColor: 'rgba(255, 255, 255, 0.5)',
fontSize: 'small',
barThickness: 2
})
},
zoomFactor: function (val, oldval) {


let k = maxSliderHeight / (maxZoomFactor - minZoomFactor)
let zoom = k * this.zoomFactor + -k * minZoomFactor
let j = (maxZoom - minZoom) / maxSliderHeight
this.displayZoom = (j * zoom + minZoom).toFixed(0)
this.zoomPercent = this.displayZoom / maxZoom * 100
}
},
mounted () {

eventBus.$emit('showLoading', false)
},
beforeMount () {
this.$vue = this

this.casePoolInfo()
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/share/caseFromShare.vue